import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, interval, BehaviorSubject } from 'rxjs';
import { map, catchError, retry, flatMap, tap, startWith, filter } from 'rxjs/operators';
import 'rxjs/add/operator/do';
import { Driver } from '../shared/driver.model';
import route from '../shared/coordinates';

@Injectable({
    providedIn: 'root'
})

export class DataService implements OnInit {
    private drivers: BehaviorSubject<Driver[]> = new BehaviorSubject([]);
    drivers$: Observable<Driver[]> = this.drivers.asObservable();

    constructor(private http: HttpClient) {
        
    }

    ngOnInit() {
        // this.fireCoordinates();
    }

    fetchDrivers(): Observable<Driver[]> {
        return this.http
            // .get<{ [key: string]: Driver }>('https://dispatcher-api.astor.ua/list', {
            // .get<{ [key: string]: Driver }>('http://localhost:3004/data', {
            .get<{ [key: string]: Driver }>('https://astorget-portfolio-default-rtdb.europe-west1.firebasedatabase.app/drivers.json', {
                responseType: 'json'
            })
            .pipe(
                map(
                    responseData => {
                        const driversArray: Driver[] = [];
                        for (const key in responseData) {
                            if (responseData.hasOwnProperty(key)) {
                                // driversArray.push({ ...responseData[key], shipment_id: parseInt(key, 10) });
                                driversArray.push({ ...responseData[key] });
                            }
                        }
                        // console.log(driversArray);
                        return driversArray;
                    }
                ),
                catchError(this.handleError)
            );
    }

    // postCoorditates() {
    //     let index = 0;
    //     let data = {
    //         [0]: {
    //            geo_lat: route[index].lat,
    //            geo_lon: route[index].lng
    //         }
    //     }
    //     console.log(data);

    //     return this.http.put('https://astorget-portfolio-default-rtdb.europe-west1.firebasedatabase.app/drivers.json', JSON.stringify(data)).subscribe(response => console.log(response));
    // }

    // fireCoordinates() {
    //     let interval;

    //     return interval = setInterval(function() {
    //         this.postCoordinates();

    //         if (this.cooIindex === route.length) {
    //             clearInterval(interval);
    //         }
    //     }, 1000);
    // }

    updateDrivers(): Observable<Driver[]> {
        return interval(100000000).pipe(
            startWith(0),
            flatMap(
                () => {
                    return this.fetchDrivers().do(
                        (drivers) => {
                            this.drivers.next(drivers);
                        }
                    );
                }
            )
        );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(
            'Something bad happened; please try again later.');
    }
}
